export const LAST_VIEWED_CLASS_COOKIE = 'last_cm_page'
export const ALL_VIEWED_CLASSES_COOKIE = 'all_cm_pages_viewed'
export const META_LAST_PRODUCT_ID_COOKIE = 'meta_last_product_id'
